var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isNoEcommerce
    ? _c(
        "div",
        {
          staticClass: "message-bar__container",
          attrs: { "data-element-id": "X_X_MainNav_Info" },
        },
        [
          !_vm.isMobile
            ? _c(
                "button",
                {
                  staticClass: "message-bar__skip-to-main-content",
                  class: {
                    "message-bar__skip-to-main-content--visible":
                      _vm.skipToMainContentIsVisible,
                  },
                  on: {
                    click: _vm.skipToMainContent,
                    focus: _vm.showSkipToMainContentButton,
                    blur: _vm.hideSkipToMainContentButton,
                  },
                },
                [_vm._v("\n    Skip to main content\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            { on: { keypress: _vm.onKeyPress } },
            [
              _c(
                "swiper",
                {
                  ref: "swiper",
                  staticClass: "message-bar__content",
                  attrs: { config: _vm.swiperConfig },
                },
                _vm._l(_vm.swiperSlides, function (slot, index) {
                  return _c(
                    "rb-dynamic-swiper-slide",
                    { key: index, attrs: { index: index } },
                    [_vm._t("content")],
                    2
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isNoEcommerce && _vm.isButtonVisible
            ? _c("rb-header-message-bar-button", {
                ref: "omnichannelCTA",
                attrs: { "is-clicked": _vm.isOmnichannelOpen },
                on: { buttonClicked: _vm.emitButtonClick },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }